import React from 'react';
import AccountsCard from '../shared/accountsCard/AccountsCard';
import LoginForm from './loginForm/LoginForm';


const LoginCard = props => (
  <AccountsCard {...props}>
    <LoginForm {...props} />
  </AccountsCard>
);

export default LoginCard;



/** WEBPACK FOOTER **
 ** ./src/app/modules/login/components/loginCard/LoginCard.js
 **/